const TYPE = 'SET_CONNECTION_MODE';

const action = (mode) => (dispatch) => dispatch({ type: TYPE, payload: mode });

export default { action, TYPE };
